import { Box, Card, CardContent, CircularProgress, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useCommonDoorScheduleHttp } from "./hooks/useCommonDoorScheduleHttp";
import { ScheduleDto } from "./dtos/ScheduleDto";
import { VspPortalActions } from "../../store/VspPortalActions";
import VspPortalContext from "../../store/VspPortalContext";



type SelectDayCategoryProps = {

    disabled: boolean;
    doorCode?: string;
    onSelectDayCategory( dayCategoryCode : string) : void;
    village?: string;
    width: string;

};


export const SelectDayCategory: React.FC<SelectDayCategoryProps> = ( props: SelectDayCategoryProps ) => {

    const { disabled, doorCode, onSelectDayCategory, village, width } = props;
    
    const [ isLoading, setIsLoading ] = useState< boolean >( false );
    const [ label, setLabel ] = useState< string >( 'DayCategory *' );
    const [ selectedDayCategory, setSelectedDayCategory ] = useState< string >( '' );
    const [ schedule, setSchedule ] = useState< ScheduleDto >();

    const { getSchedule } = useCommonDoorScheduleHttp( );

    const { dispatch } = useContext( VspPortalContext );

    useEffect( ( ) => {
        
        const fetchSchedule = async ( ) => {

            if( !doorCode || !village  ){
                return;
            }

            reset();

            setIsLoading( true );
            const scheduleDto = await getSchedule( doorCode, village  );
            setIsLoading( false );

            if( scheduleDto ) {
                
                setSchedule( scheduleDto );
                dispatch({ type: VspPortalActions.SetSchedule, payload: scheduleDto });

            }

        }; 
        fetchSchedule( );

    }, [ doorCode, village ] );


    useEffect( () => {

        if(disabled){
            
            reset();
            
        }

    }, [ disabled ]);
    
    
    const handleDayCategoryChange = ( event: SelectChangeEvent ) => {
    
        const selectedDayCategory: string = event.target.value;
        
        setSelectedDayCategory( selectedDayCategory );
        onSelectDayCategory( selectedDayCategory );
        setLabel( 'DayCategory' );

    }


    const reset = () => {

        setSelectedDayCategory( '' );
        setLabel( 'DayCategory *' );

        onSelectDayCategory( '' );

    };


    return (

        <>
            {   
                isLoading
                    ?
                <Card variant="outlined" sx = {{ height: '54px', width: width }}>
                
                    <CardContent>
                        <Stack direction="row" sx={{ display: "flex" }}>

                            <Typography >
                                DayCategory *
                            </Typography>

                            <Box sx={{ flexGrow: 1 }} />

                            <CircularProgress size={ 30 } sx={{ color: '#e65400', marginTop: '-3px' }}/>

                        </Stack>
                    </CardContent>

                </Card>
                    :
                <FormControl sx={{ width: width }}>
                    <InputLabel> { label } </InputLabel>
                    <Select
                        disabled={ isLoading || disabled }
                        onChange={ handleDayCategoryChange }
                        value={ selectedDayCategory }
                        label={ label }
                    >
                        { schedule?.dayCategories.map( m => (
                            <MenuItem value={ m.dayCategory.name } key={ m.dayCategory.name }>{ m.dayCategory.name }</MenuItem>
                        ))}
                    </Select>
                </FormControl>

            }

        </>

    );

};